import { Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { db } from "../../firebase/FirebaseConfig";
import { collection, getDocs, setDoc, doc } from "firebase/firestore";
import Tooltip from "@mui/material/Tooltip";
import emojis from "../CLUB/emojisData.json";
export default function AddNewCalendarEvent() {
  const [activityDate, setActivityDate] = useState<string>("");
  const [activityEmoji, setActivityEmoji] = useState<string>("");
  const [activityTitle, setActivityTitle] = useState<string>("");
  const [activityDetails, setActivityDetails] = useState<string>("");
  const [activityHost, setActivityHost] = useState<string>("");
  const handleAddingNewCalendarEvent = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "inClubActivities"));
      const events = querySnapshot.docs.map((doc) => doc.data());
      const nextId =
        events.length > 0
          ? Math.max(...events.map((e) => e.activityId || 0)) + 1
          : 0;

      const newEvent = {
        activityTitle,
        activityDate,
        activityDetails,
        activityEmoji,
        activityHost,
        activityId: nextId,
      };

      await setDoc(doc(db, "inClubActivities", nextId.toString()), newEvent);
      alert("Event added successfully!");
    } catch (error) {
      console.error("Error adding event:", error);
      alert("Failed to add event.");
    }
  };
  const EmojiButton = (emoji: string, label: string) => {
    return (
      <div style={{ paddingTop: 10 }}>
        <Tooltip
          title={label}
          enterDelay={0}
          leaveDelay={0}
          arrow
          placement="top"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginRight: 10,
              gap: 1,
              wordBreak: "break-word",
            }}
          >
            <button
              onClick={() => {
                setActivityEmoji(emoji);
              }}
              style={{ padding: 8, fontSize: 20 }}
            >
              {emoji}
            </button>
          </div>
        </Tooltip>
      </div>
    );
  };

  useEffect(() => {
    const fetchLatestEventDate = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "inClubActivities"));
        const events = querySnapshot.docs.map((doc) => doc.data());
        if (events.length === 0) return;
        const latestEvent = events.reduce((max, curr) =>
          curr.activityId > max.activityId ? curr : max
        );
        setActivityDate(latestEvent.activityDate || "");
      } catch (error) {
        console.error("Failed to fetch latest event:", error);
      }
    };
    fetchLatestEventDate();
  }, []);

  return (
    <>
      <div className="faq">
        
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <h1>ADD NEW CALENDAR EVENT</h1>
          <h5>(to the calendar everybody reads soooo much)</h5>
        </div>
        <div style={{ paddingLeft: 10, paddingRight: 10 }}>
          <TextField
            size="small"
            sx={{ width: "50%", marginBottom: 2.5 }}
            value={activityTitle}
            onChange={(e) => setActivityTitle(e.target.value)}
            label="Activity Title"
          ></TextField>

          <TextField
            value={activityDetails}
            onChange={(e) => setActivityDetails(e.target.value)}
            fullWidth
            multiline
            rows={3}
            maxRows={6}
            style={{ marginBottom: 30 }}
            label="Activity Description"
          />
          <h3>
            Date:
            <input
              type="date"
              value={activityDate}
              style={{ marginLeft: 10 }}
              onChange={(e) => {
                setActivityDate(e.target.value);
              }}
            />
          </h3>
          <h6 style={{ marginBottom: 30 }}>
            The initial starting date for this input is the date of the most
            recent event.
          </h6>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontWeight: "bold",
            }}
          >
            <TextField
              size="small"
              value={activityEmoji}
              sx={{ width: 70, textAlign: "center" }}
              onChange={(e) => setActivityEmoji(e.target.value)}
              label="Emoji"
            />
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 0fr)",
              justifyItems: "center",
              paddingTop: 5,
            }}
          >
            {emojis.map((emoticon, index) =>
              EmojiButton(emoticon.emoji, emoticon.label)
            )}
          </div>
          <h6 style={{ marginTop: 5, marginBottom: 30 }}>
            You can paste any emoji into the text box, the buttons are for your
            convenience.
          </h6>

          <TextField
            value={activityHost}
            onChange={(e) => setActivityHost(e.target.value)}
            size="small"
            label="Activity Host"
          />
          <div></div>
          <Button
            onClick={handleAddingNewCalendarEvent}
            variant="contained"
            style={{
              marginTop: 30,
            }}
          >
            SUBMIT NEW CALENDAR EVENT
          </Button>
        </div>
      </div>
    </>
  );
}
